module.exports = __webpack_public_path__ + "static/media/Employment skills for my chosen career.2ab8d2b7.pdf";